<app-display-information-page [title]="pageTitle" (acceptMember)="addMember()" (refuseMember)="refuseMember()"
                              [content]="content" [group]="group" [link]="link" [showButton]="showButton"
                              [showGroupLink]="showGroupLink" [disabledButton]="disabledButton" [isClosedGroup]="isClosedGroup"></app-display-information-page>
<app-confirm-dialog [confirmText]="yesText" [cancelText]="noText" ></app-confirm-dialog>

